import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import { useDropzone } from 'react-dropzone'
import {
  Button,
  Icon,
  Spacing,
  Text
} from '@ui'
import { t } from 'i18next'
import { uploadFile } from '@app/util/upload-file'

export const UploadButton = ({ workspaceId, auth, onUpload }) => {
  const [, setFiles] = useState([])
  const onDrop = useCallback((newFiles) => {
    uploadFile(newFiles, workspaceId, auth).then((res) => {
      setFiles((prev) => {
        const newArr = newFiles.map((item, index) => res[index]).concat(prev)
        onUpload(newArr)
        return newArr
      })
    })
  }, [])

  const {
    getRootProps
  } = useDropzone({
    multiple: true,
    onDrop
  })
  return (
    <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
      <Text
        text={t('ATTACHMENT')}
        type={Text.TYPES.BODY_MEDIUM}
        weight={Text.WEIGHTS.BOLD}
      />
      <Spacing size={Spacing.SIZES.SIZE_6} />
      <div {...getRootProps()} style={{ width: '100%' }}>
        <Button
          label={t('ATTACHMENT_UPLOAD')}
          onClick={async () => {
            if (!('showOpenFilePicker' in window)) {
              window.alert('File System Access API not supported in this browser. Please use a modern browser like Chrome or Edge.')
            }

            try {
              const fileHandles = await window.showOpenFilePicker({
                multiple: true,
                types: [
                  {
                    description: 'All Files',
                    accept: { '*/*': [] }
                  }
                ]
              })

              const files = await Promise.all(fileHandles.map(handle => handle.getFile()))

              onDrop(files)
            } catch (error) {
              if ((error).name !== 'AbortError') {
                console.error('Error selecting file:', error)
              }
            }
          }}
          ico={Icon.ICONS.upload}
          style={Button.STYLES.OUTLINED}
          color={Button.COLORS.PRIMARY}
          size='FULL'
        />
      </div>
    </div>
  )
}

UploadButton.propTypes = {
  workspaceId: PropTypes.string.isRequired,
  auth: PropTypes.string.isRequired,
  onUpload: PropTypes.func
}
UploadButton.defaultProps = {
  onUpload: () => null
}
